import { Form } from 'antd'
import { useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { appRoutes } from '../../../containers/Router/routes'
import { useCreateMutation } from '../../../query'

const useUserCreate = () => {
  const [form] = Form.useForm()

  const history = useHistory()

  const [createUser, { status: createStatus }] = useCreateMutation('users')

  const onFinish = useCallback(async () => {
    try {
      const values = await form.validateFields()
      const user = await createUser({
        ...values
      })

      history.replace(
        generatePath(appRoutes.userEdit.path, {
          id: user._id
        })
      )
    } catch (e) {
      console.log(e)
    }
  }, [form])

  return {
    form,
    onFinish,
    createLoading: createStatus === 'loading'
  }
}
export default useUserCreate
